import React from 'react'
import { View } from 'react-native'
import Text from '../Text'

const ModalComplicationMacrovasculaireEvoluee = () => {
  return (
    <View>
      <Text>{'Considéré comme évoluée : infarctus du myocarde avec insuffisance cardiaque, atteinte coronarienne sévère (tronc commun ou atteinte tritronculaire ou atteinte de l’interventriculaire antérieur proximal), atteinte polyartérielle (au moins deux territoires artériels symptomatiques), artériopathie oblitérante des membres inférieurs symptomatique et accident vasculaire cérébral récent (< 6 mois).'}</Text>
    </View>
  )
}

export default ModalComplicationMacrovasculaireEvoluee
